enum LoadingAppType {
  LOADING_APP_SUCCESS = "LoadingApp/LOADING_APP_SUCCESS",
}

export interface ILoadingAppState {
  readonly loading: boolean;
}

export default LoadingAppType;
